import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import {
  MdCameraAlt,
  MdFace,
  MdDone,
  MdClear,
  MdCreate,
  MdAdd,
} from 'react-icons/md';
import { BsPlusSquareFill } from 'react-icons/bs';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import classnames from 'classnames';
import PosSMSAlertForm from '../components/PosSMSAlertForm';
import { IconContext } from 'react-icons/lib';

class PosSMSAlertTable extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      smsList: [],
      modal: false,
      confirmModal: false,
      sms: '',
      report_type: '',
      selectedData: '',
      selectedId: '',
      store_id: '',
    };
  }

  componentDidMount() {
    this.SMSAlert();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

    SMSAlert = () => {
        const user = StorageService.getSession('user_info');
        const comp = StorageService.getSession('selected_org');
        const url = process.env.REACT_APP_UNITY_API2_URL;
        const data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        company_id: comp.CompanyID,
        store_id: this.props.match.params.id,
        };

        axios
        .post(url + ':3001/v1/store/smsalert', data)
        .then(response => {
            const result = response.data;
            if (result.error == true && result.message != 'Success') {
            alert(result.message);
            return;
            }

            if (this._isMounted) {
            this.setState({
                smsList: result.data,
                store_id: this.props.match.params.id,
            });
            }
        })
        .catch(error => {
            alert(error);
        });
    };

  toggle = (action, mobile, report_type) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
      mobile != undefined || (mobile != null && action == 'EDIT')
          ? true
          : false,
      selectedId:
      mobile != undefined || (mobile != null && action == 'EDIT') ? mobile : '',
      selectedData:
        report_type != undefined || (report_type != null && action == 'EDIT')
          ? report_type
          : '',
    });
  };

  toggleConfirmModal = (mobile, report_type) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: report_type,
      selectedId: mobile,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.SMSAlert();
    }
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    let data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      mobile: this.state.selectedId,
      report_type: this.state.selectedData,
      store_id: this.props.data.store_id,
      remove_by: user.email,
    };

    axios
      .post(url + ':3001/v1/store/smsalert/remove', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `SMS Alert ${
            this.state.isGlobal ? 'deleted' : 'removed'
          } successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        this.SMSAlert();
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <div className="text-right mb-3">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className="ps-table tb-col-3">
          <thead>
            <tr>
              <th>Mobile No</th>
              <th>Report Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.smsList.length < 1 && (
              <tr>
                <td colSpan="3">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new promo</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.smsList.length > 0 &&
              this.state.smsList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.mobile}</td>
                    <td>{item.report_type}</td>
                    <td>
                      <div className="ps-action-button">
                        {/* <Button
                          className="theme-button theme-button-secondary"
                          onClick={this.toggle(
                            'EDIT',
                            item.email,
                            item.report_type,
                          )}
                        >
                          Edit
                        </Button> */}
                        <Button
                          className="theme-button theme-button-primary-light"
                          onClick={this.toggleConfirmModal(
                            item.mobile,
                            item.report_type,
                          )}
                        >
                          {this.state.isGlobal ? 'Delete' : 'Remove'}
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <PosSMSAlertForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>
        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            {this.state.isGlobal ? 'Delete' : 'Remove'} SMS Alert
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to{' '}
                  {this.state.isGlobal ? 'delete' : 'remove'}{' '}
                  {this.state.selectedData} for {this.state.selectedId} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              No
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default PosSMSAlertTable;
